export default {"src":"/_next/static/media/qr-code.125efa44.svg","height":1155,"width":1155,"blurWidth":0,"blurHeight":0};